export const PENGKINIAN_DATA_PATH = "/info/pengkinian-data-pelanggan";
export const UPLOAD_KUITANSI_PATH = "/info/upload-kuitansi";
export const DIRECT_DEBIT_PATH = "/cara-pembayaran/bayar-otomatis";
export const DIRECT_DEBIT_WIDGET = "/livechathcid/direct-debit/widgets.min.js";
export const UPDATE_DATA_WIDGET = "/livechathcid/widgets.min.js";
export const WIDGET_STYLE = "/livechathcid/widgets.min_beauty.css";
